import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
    },
    cards: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gridColumnGap: theme.spacing(2)
    },
  });

export const useStyles = makeStyles(styles);
